import React, { useContext } from "react";
import CountdownTimer from "../SpeedMeeting/CountdownTimer";

import { useRouter } from "next/router";
import { isMobileOrTablet } from "../Views/MobileClassRenderer";
import { UserContext } from "../../contexts/UserContext";

export default function MeetingPlayer(props) {
  const {
    wherebyMeetingHostRoomUrl,
    wherebyMeetingRoomUrl,
    isAgent = false,
    isSpeedMeeting,
    createdAt,
    speedMeetingDurationMinutes,
    isModerator,
  } = props;

  const router = useRouter();
  const { me } = useContext(UserContext);

  const isSpeedMeetingSettings = `screenshare=off&chat=off&skipMediaPermissionPrompt`;
  const isMeetingSettings = `screenshare=on&chat=on`;

  return (
    <>
      <iframe
        src={`${
          isModerator || isAgent
            ? `${wherebyMeetingHostRoomUrl}&embed&iframeSource=onemotion&background=off&${
                isSpeedMeeting ? isSpeedMeetingSettings : isMeetingSettings
              }&recording=on&people=on&breakout=on&record=off&displayName=${
                me?.user?.firstName
              }&localization=off`
            : `${wherebyMeetingRoomUrl}?minimal&people=off&${
                isSpeedMeeting ? isSpeedMeetingSettings : isMeetingSettings
              }&displayName=${me?.user?.firstName}&localization=off`
        }`}
        frameBorder="0"
        style={{
          position: "fixed",
          top: `${!isMobileOrTablet() ? "calc(52px + 2em)" : "90px"}`,
          left: "0",
          width: "100vw",
          height: `${
            !isMobileOrTablet()
              ? "calc(((100vh - 48px) - 52px) - 2em)"
              : "calc(100% - 90px - (env(safe-area-inset-bottom)))"
          }`,
          zIndex: "5",
        }}
        allow="camera; microphone; fullscreen; speaker; display-capture"
      ></iframe>
      {isSpeedMeeting && (
        <CountdownTimer
          startAt={createdAt}
          durationInMinutes={speedMeetingDurationMinutes}
          onFinish={() => router.back()}
        />
      )}
    </>
  );
}
